"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const _360_Luz_svg_1 = __importDefault(require("../../../../assets/images/360-Luz.svg"));
const digital_lock_webp_1 = __importDefault(require("../../../../assets/images/digital-lock.webp"));
const kitchen_svg_1 = __importDefault(require("../../../../assets/images/kitchen.svg"));
const wifizone_webp_1 = __importDefault(require("../../../../assets/images/wifizone.webp"));
require("./AboutStyles.scss");
const Minicard_1 = __importDefault(require("./components/miniCard/Minicard"));
const About = (0, react_1.forwardRef)((_, ref) => {
    const cards = [
        {
            title: 'Cuidamos do seu imóvel como se fosse nosso',
            desc: 'Seu patrimônio, nossa responsabilidade. Criamos uma estrutura pensada exclusivamente nas vantagens de nossos investidores. Com a 360, você conta com um time de especialistas focados na administração completa do seu apartamento.',
            image: kitchen_svg_1.default,
            id: 0,
        },
        {
            title: 'Canal omnichannel de vendas',
            desc: 'Criamos uma estrutura de vendas com foco total no aumento da sua rentabilidade. Além de oferecer um motor de reservas interno rápido e descomplicado, somos parceiros das plataformas de vendas mais eficientes do mercado de hospedagem. Assim, seu imóvel nunca fica vazio.',
            image: wifizone_webp_1.default,
            id: 1,
        },
        {
            title: 'Aluguel sem dor de cabeça',
            desc: 'Do check-in ao check-out, cuidamos de todas as etapas do processo de locação temporária do seu imóvel. Realizamos mais de 2 mil check-ins mensais sob uma estrutura robusta de tecnologia, administração transparente, limpeza profissional das unidades e atendimento personalizado 24 horas.',
            image: _360_Luz_svg_1.default,
            id: 2,
        },
        {
            title: 'Resultados na palma da sua mão',
            desc: 'Acompanhe diariamente a performance do seu patrimônio em nosso portal do investidor. Nele, você tem acesso privado e seguro a todas as reservas realizadas em seu imóvel, além de ficar por dentro dos detalhes de faturamento e simulações do mercado.',
            image: digital_lock_webp_1.default,
            id: 3,
        },
    ];
    return (react_1.default.createElement("div", { className: "About", ref: ref },
        react_1.default.createElement("span", { className: "about-title" }, "NOSSOS SERVI\u00C7OS"),
        react_1.default.createElement("span", null,
            "Como",
            react_1.default.createElement("span", null, ` Funciona`)),
        react_1.default.createElement("span", null, "Cansado de perder dinheiro com imobili\u00E1rias ou administradoras?"),
        react_1.default.createElement("div", { className: "minicards" }, cards.map(card => (react_1.default.createElement(Minicard_1.default, { card: card, key: card.id }))))));
});
exports.default = About;
